import { useOrganization, useUser } from "@clerk/nextjs"

import { hasCovalAdminAccess } from "@/utils/auth/coval-admin-access"

import { FEATURE_FLAGS } from "../flags"
import { usePostHydrationFeatureFlagValue } from "./FeatureFlag"
import { useOrganizationFeatureFlagScope } from "./FeatureFlagsProvider"

export function useSofiaGithubFeatureFlag(): boolean | undefined {
  const { organization } = useOrganization()
  const { isLoaded: userLoaded, user } = useUser()
  const flag = usePostHydrationFeatureFlagValue(
    FEATURE_FLAGS.SOFIA_GITHUB_CONNECTIONS,
  )
  const scope = useOrganizationFeatureFlagScope()
  if (
    process.env.NEXT_PUBLIC_SOFIA_GITHUB_CONNECTIONS_ENABLED !== "true" ||
    scope.hasError
  ) {
    return false
  }
  if (!userLoaded) {
    return undefined
  }
  const primaryEmail = user?.primaryEmailAddress
  if (
    primaryEmail?.verification?.status !== "verified" ||
    !hasCovalAdminAccess(primaryEmail)
  ) {
    return false
  }
  if (
    !organization ||
    !scope.isReady ||
    scope.organizationId !== organization.id
  ) {
    return undefined
  }
  return flag
}
